export default "__VITE_ASSET__4da0ffe9__"